"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  MenuProps: {
    anchorOrigin: {
      horizontal: 'center',
      vertical: 'bottom'
    },
    getContentAnchorEl: null,
    PaperProps: {
      style: {
        margin: '5px 0 0 8px'
      }
    },
    transformOrigin: {
      horizontal: 'center',
      vertical: 'top'
    }
  }
};